/**
 * created by xcc on 2022/2/23
 * 部门树组件
 */

import React, {Component} from 'react';
import {Button, Tree, Modal, Input, Empty} from "antd";
import Scrollbars from "react-custom-scrollbars";
import {uuid} from "../../../utils";

const {TreeNode} = Tree;
const {Search} = Input;

export default class DeptTree extends Component {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            deptVisible: false,
            checkedNodeKey: [],
            checkedNodeName: [],
            searchText: "",
            loadKey: uuid()
        }
    }

    componentWillMount() {

    }

    componentDidMount() {

    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            deptVisible: nextProps.deptVisible,
            checkedNodeKey: nextProps.checkedNodeKey,
            checkedNodeName: nextProps.checkedNodeName,
        })
    }

    loadKey = () => {
        this.setState({
            loadKey: uuid(),
            searchText: "",
        })
    }

    /**
     * 渲染
     */
    render() {
        //搜索(处理渲染节点)
        let hasSearchText = this.hasSearchText(this.props.departAllList);
        return (
            <div>
                <Modal
                    title={"选择部门"}
                    visible={this.state.deptVisible}
                    width={400}
                    height={300}
                    key={this.state.loadKey}
                    onCancel={() => {
                        this.props.onCancelChecked()
                    }}
                    className={"deptTree"}
                    maskClosable={false}
                    footer={
                        <div style={{textAlign: "center"}}>
                            <Button onClick={() => {
                                this.props.onCancelChecked()
                            }}>取消</Button>
                            <Button type={"primary"} onClick={() => {
                                this.props.onOkCheck(this.state.checkedNodeKey, this.state.checkedNodeName);
                            }}>确定</Button>
                        </div>
                    }
                >
                    <div style={{width: "100%"}}>
                        {this.props.showSearch ?
                            <Search placeholder={"请输入关键词"}
                                    style={{margin: "10px 0px", width: 270}}
                                    onSearch={(val) => {
                                        this.setState({
                                            searchText: val
                                        })
                                    }}
                            /> : null}
                        <Scrollbars autoHide autoHeight autoHeightMax={500}>
                            <div>
                                {!hasSearchText ? <Empty/> :
                                    <Tree
                                        checkable={true}
                                        onCheck={this.onCheck}
                                        checkedKeys={this.state.checkedNodeKey}
                                        checkStrictly
                                        defaultExpandAll
                                        selectable={false}
                                    >
                                        {this.renderTreeNodes(this.props.departAllList)}
                                    </Tree>}
                            </div>
                        </Scrollbars>
                    </div>
                    <style>{
                        `.deptTree .ant-modal-body{padding: 0px 0px 0px 15px}`
                    }</style>
                </Modal>
            </div>
        )
    }

    renderTreeNodes = (data, hasSearch) => {
        return (
            data.map(item => {
                if (item.sons) {
                    return (
                        <TreeNode key={item.id} title={this.renderTitle(item)} dataRef={item}>
                            {this.renderTreeNodes(item.sons)}
                        </TreeNode>
                    )
                }
                //搜索(处理渲染节点)
                let hasSearchText = this.hasSearchText([item]);
                if (!hasSearch && !hasSearchText) {
                    return "";
                }
                if (item.child) {
                    return (
                        <TreeNode key={item.id} title={this.renderTitle(item)} dataRef={item}>
                            {this.renderTreeNodes(item.child, hasSearchText)}
                        </TreeNode>
                    )
                }
                return <TreeNode key={item.id} dataRef={item} {...item} title={this.renderTitle(item)}/>;
            })
        );
    }

    renderTitle(item) {
        item.title = item.name;
        let searchVal = this.state.searchText;
        const index = item.title.indexOf(searchVal);
        const beforeStr = item.title.substr(0, index);
        const afterStr = item.title.substr(index + searchVal.length);
        const title =
            index > -1 ? (
                <span style={{
                    width: 100,
                    overflow: 'hidden',
                    marginLeft: '5px',
                    textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                }}>
              {beforeStr}
                    <span style={{color: '#f50'}}>{searchVal}</span>
                    {afterStr}
            </span>
            ) : (
                <span style={{
                    width: 100,
                    overflow: 'hidden',
                    marginLeft: '5px',
                    textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                }}>{item.title}</span>
            );
        return title;
    }

    hasSearchText = (node) => {
        let {searchText} = this.state;
        if (!searchText) {
            return true
        }
        if (node && node.length) {
            return node.some(item => {
                if (item.name.indexOf(searchText) > -1) {
                    return true
                }
                if (item.sons && item.sons.length) {
                    return this.hasSearchText(item.sons)
                }
                if (item.child && item.child.length) {
                    return this.hasSearchText(item.child)
                }
            })
        } else {
            return false
        }
    }

    //点击树选框
    onCheck = (checkedNodeKey, e) => {
        while (checkedNodeKey.checked.length > 1) {
            checkedNodeKey.checked.shift();
        }
        while (e.checkedNodes.length > 1) {
            e.checkedNodes.shift();
        }
        this.setState({
            checkedNodeKey: checkedNodeKey.checked,
            checkedNodeName: e.checkedNodes.length > 0 ? [e.checkedNodes[0].props.dataRef.name] : []
        })
    }
}